import React from "react";
import { Outlet } from "react-router-dom";
import "@fontsource/work-sans"; // Defaults to weight 400
import "@fontsource/work-sans/400.css"; // Specify weight
import "@fontsource/work-sans/400-italic.css"; // Specify weight and style
import 'bootstrap/dist/css/bootstrap.min.css';
import "./../../assets/css/setup.css";
const SetupLayout = () => {
  return (
    <div className="h-100">
      <div className="outerBackgroundDiv">
        <div className="Background">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <Outlet />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupLayout;
